import mixpanel from 'mixpanel-browser'
import { getFingerprintId } from './fingerprint'

let isInitialized = false

export async function initMixpanel() {
    if (isInitialized) return

    mixpanel.init('c7bafc0c73ed187a6aa403720f1acfb2', {
        persistence: 'localStorage',
    })

    const fingerprintId = await getFingerprintId()

    mixpanel.register({
        fingerprint_id: fingerprintId,
    })

    isInitialized = true
}

export async function trackEvent(eventName, props = {}) {
    if (!isInitialized) {
        await initMixpanel()
    }

    const fingerprintId = await getFingerprintId()

    const payload = {
        ...props,
        fingerprint_id: fingerprintId,
    }

    console.log(`[Mixpanel] ${eventName}`, payload)

    mixpanel.track(eventName, payload)
}

export function identifyUser(userId, props = {}) {
    if (!isInitialized) {
        mixpanel.init('c7bafc0c73ed187a6aa403720f1acfb2', {
            persistence: 'localStorage',
        })

        isInitialized = true
    }

    mixpanel.identify(userId)
    mixpanel.register({
        user_id: userId,
    })

    if (Object.keys(props).length) {
        mixpanel.people.set(props)
    }
}
